import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.471 6.195c.26.26.26.683 0 .943L3.61 10l2.862 2.862a.667.667 0 1 1-.942.943L2.195 10.47a.667.667 0 0 1 0-.942L5.53 6.195c.26-.26.682-.26.942 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.333 2c.368 0 .667.298.667.667v4.666a3.333 3.333 0 0 1-3.333 3.334h-8a.667.667 0 0 1 0-1.334h8a2 2 0 0 0 2-2V2.667c0-.369.298-.667.666-.667",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })